<template>
  <div>
    <div class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="modal" :data-target="'#edit_level_modal_'+row.id">
      <i class="fa fa-eye"></i>
    </div>
    <div :id="'edit_level_modal_' + row.id" class="modal fade rtl" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header mx-auto">
            <h4 class="modal-title">
              {{ $t('label.level') }} {{ ' ' + row.id }}
            </h4>
          </div>
          <div class="modal-body mb-4 mx-4">
            <form :id="'edit_level_form_' + row.id" class="kt-form" @submit.prevent="editLevel">
                <kt-form-section>
                  <kt-form-row>
                    <kt-col xs="12" sm="12" md="12">
                      <kt-form-group class="d-flex flex-column align-items-start">
                        <kt-form-label :for="'level_name_' + row.id">
                          {{ $t('label.level_name') }}
                        </kt-form-label>
                        <kt-form-control
                            type="text"
                            :ref="'level_name_' + row.id"
                            placeholder="سطح 1"
                            dir="rtl"
                            :name="'level_name_' + row.id"
                            :id="'level_name_' + row.id"
                            v-model="level_name"
                        />
                      </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="12" md="12">
                      <kt-form-group class="d-flex flex-column align-items-start">
                        <kt-form-label :for="'settlement_limit_' + row.id">
                          {{ $t('label.settlement_limit') }}
                        </kt-form-label>
                        <kt-form-control
                            type="number"
                            placeholder="ریال"
                            :ref="'settlement_limit_' + row.id"
                            dir="rtl"
                            :name="'settlement_limit_' + row.id"
                            :id="'settlement_limit_' + row.id"
                            v-model="settlement_limit"
                        />
                        <span v-if="settlement_limit >= 10">
                        <span v-text="Num2persian(Math.floor(settlement_limit / 10))"></span>&nbsp;
                        <span v-text="$t('label.toman')"></span>
                    </span>
                      </kt-form-group>
                    </kt-col>
                    <kt-col class="my-3 d-flex flex-column align-items-start" xs="12" sm="6" md="6">
                      <div class="custom-switch custom-control">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'iban_national_id_matching_' + row.id"
                            :name="'iban_national_id_matching_' + row.id"
                            v-model="iban_national_id_matching"
                        >
                        <label class="custom-control-label" :for="'iban_national_id_matching_' + row.id">{{ $t('label.iban_national_id_matching') }}</label>
                      </div>
                    </kt-col>
                    <kt-col class="my-3 d-flex flex-column align-items-start" xs="12" sm="6" md="6">
                      <div class="custom-switch custom-control">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'phone_national_id_matching_' + row.id"
                            :name="'phone_national_id_matching_' + row.id"
                            v-model="phone_national_id_matching"
                        >
                        <label class="custom-control-label" :for="'phone_national_id_matching_' + row.id">{{ $t('label.phone_national_id_matching') }}</label>
                      </div>
                    </kt-col>
                    <kt-col class="my-3 d-flex flex-column align-items-start" xs="12" sm="6" md="6">
                      <div class="custom-switch custom-control">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'otp_authentication_condition_' + row.id"
                            :name="'otp_authentication_condition_' + row.id"
                            v-model="otp_authentication_condition"
                        >
                        <label class="custom-control-label" :for="'otp_authentication_condition_' + row.id">{{ $t('label.otp_authentication_condition') }}</label>
                      </div>
                    </kt-col>
                    <kt-col xs="12" sm="12" md="12" class="mt-2">
                      <div class="kt-login__actions mt-4 mx-2">
                        <kt-button type="submit" :id="'edit_level_btn_' + row.id" variant="brand" class="px-4 btn btn-success">
                            {{ $t('label.edit') }}
                        </kt-button>
                      </div>
                    </kt-col>
                  </kt-form-row>
                </kt-form-section>
              </form>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import $ from "jquery";
import {KTApp} from '@/plugins/core/app'
import {i18n} from "@/plugins/i18n";
import toastr from "toastr";
import Inputmask from "inputmask";
import {depositPfService, depositStarshopService, walletService} from "@/common/api.service";
import Num2persian from "num2persian";

export default Vue.extend({
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    }
  },
  data() {
    return {
      level_name: null,
      settlement_limit: "",
      iban_national_id_matching: false,
      phone_national_id_matching: false,
      otp_authentication_condition: false,
      Num2persian
    }
  },
  methods: {
    editLevel() {
        let form = $(`#edit_level_form_${this.row.id}`)
        let btn = $(`#edit_level_btn_${this.row.id}`)

        form.validate({
            rules: {
                level_name: {
                    required: true
                },
                settlement_limit: {
                    required:true
                },
            }
        })

        if (!form.valid()) {
            return
        }
        KTApp.progress(btn)

        let params = {
            name: this.level_name,
            settlement_limit: this.settlement_limit,
            iban_national_id_matching: this.iban_national_id_matching,
            phone_national_id_matching: this.phone_national_id_matching,
            otp_authentication_condition: this.otp_authentication_condition,
        }

        walletService.editLevelForShareholder(params, this.row.id)
            .then(response => {
                this.toastr.success(response.data.message)
                $(`#edit_level_modal_${this.row.id}`).modal("hide")
                this.datatable.reload()
            })
            .catch(({response}) => {
                this.toastr.error(response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }
      return toastr
    },
  },
  mounted() {
    this.level_name = this.row.name
    this.settlement_limit = this.row.settlement_limit.replaceAll(',', '')
    this.iban_national_id_matching = this.row.iban_national_id_matching
    this.phone_national_id_matching = this.row.phone_national_id_matching
    this.otp_authentication_condition = this.row.otp_authentication_condition
  }
})
</script>

<style>

</style>
